import { useAreas } from '@/modules/areas/useAreas';
import { useAreaFilter } from '@/store/areaFilter';
import { AreaDot } from '@/modules/areas/AreaDot';
import { cn } from '@/lib/utils/cn';
import { de } from '@/i18n/de';

/**
 * Der globale Bereichsfilter.
 *
 * Er steht bewusst in der App-Huelle und nicht in einem Modul: er wirkt
 * gleichzeitig auf Kalender, Aufgaben und alles Spaetere. Genau das ist der
 * Zweck von Bereichen.
 */
export function AreaFilterBar() {
  const areas = useAreas();
  const { activeAreaIds, isActive, toggleArea, clearAreaFilter } = useAreaFilter();

  if (areas.length === 0) return null;

  return (
    <div
      role="group"
      aria-label={de.areas.filterHint}
      className="flex flex-wrap items-center gap-1.5"
    >
      <Chip active={!isActive} onClick={clearAreaFilter}>
        {de.areas.filterAll}
      </Chip>

      {areas.map((area) => {
        const on = activeAreaIds.includes(area.id);
        return (
          <Chip key={area.id} active={on} onClick={() => toggleArea(area.id)}>
            <AreaDot color={area.color} size="sm" />
            {area.name}
          </Chip>
        );
      })}
    </div>
  );
}

function Chip({
  active, onClick, children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-sm',
        'transition-colors',
        active
          ? 'border-line-strong bg-surface-raised text-ink'
          : 'border-line text-ink-muted hover:text-ink',
      )}
    >
      {children}
    </button>
  );
}
